import React from 'react'
import Div from '@jarvis.oddle/core/components/Div'
import Flex from '@jarvis.oddle/core/components/Flex'
import DivButton from '@jarvis.oddle/core/components/DivButton'
import IconEdit from '@jarvis.oddle/core/components/Icons/IconEdit'

interface ContainerProps {
  children: React.ReactNode[] | React.ReactNode
  onClick: () => void
}

export const Container = ({
  children,
  onClick,
  ...props
}: ContainerProps): JSX.Element => {
  return (
    <DivButton {...props} onClick={onClick}>
      <Flex justifyContent='space-between' alignItems='center'>
        {children}
        <Div>
          <IconEdit />
        </Div>
      </Flex>
    </DivButton>
  )
}
